import { debounce, isEmpty, method } from "lodash";
import queryString from "query-string";

const isDevelopment = process.env.NODE_ENV === "development";
export const APP_NAVIGATE_URL = isDevelopment
  ? "https://truyxuat.cachinhbong.com/"
  : process.env["REACT_APP_URI"] || "https://truyxuat.cachinhbong.com/";


export const API_CORE_URI = isDevelopment
  ? "https://getway.cachinhbong.com/api/admin/"
  : process.env["REACT_APP_API_CORE_URI"] || "https://getway.cachinhbong.com/api/admin/";

  export const API_DMS_URI = isDevelopment
  ? "https://getway.cachinhbong.com/api/dms/"
  : process.env["REACT_APP_API_DMS_URI"] || "https://getway.cachinhbong.com/api/dms/";

export const API_SPATIAL_URI = isDevelopment
  ? "https://getway.cachinhbong.com/api/spatial/"
  : process.env["REACT_APP_API_SPATIAL_URI"] ||
    "https://getway.cachinhbong.com/api/spatial/";


    export const API_GEOSERVER_URI = isDevelopment
    ? "https://geoserver.cachinhbong.com/geoserver/CaChinhBong/wms"
    : process.env["REACT_APP_API_GEO_URI"] ||
      "https://geoserver.cachinhbong.com/geoserver/CaChinhBong/wms";
  export const API_GEOSERVER_URI_QUERY = isDevelopment
    ? "https://geoserver.cachinhbong.com/geoserver/CaChinhBong/ows"
    : process.env["REACT_APP_API_GEO_URI_QUERY"] ||
      "https://geoserver.cachinhbong.com/geoserver/CaChinhBong/ows";


var CurrentUser = null;
export function setCurrentUser(user) {
  CurrentUser = user;
}

function getHeaders() {
  if (CurrentUser) {
    return {
      "Content-Type": "application/json",
      Authorization: "Bearer " + CurrentUser.access_token
    };
  }

  return { "Content-Type": "application/json" };
}
function getHeaderFile() {
  if (CurrentUser) {
    return {
      // 'Content-Type': 'multipart/form-data; boundary',
      Authorization: "Bearer " + CurrentUser.access_token
    };
  }

  return { "content-type": "multipart/form-data" };
}

export function callAPI({ method, path, data, getBody }) {
  if (method !== "GET" && method !== "DELETE" && method !== "PUT") {
    method = "POST";
  }
  if (method === "GET") {
    const qr = queryString.stringify({ ...data });
    if (qr !== "") {
      path = path + "?" + qr;
    }
    if (getBody) {
      data = getBody;
    } else {
      data = null;
    }
  }

  return new Promise((resolve, reject) => {
    const timeoutId = setTimeout(() => {
      return resolve({
        code: 408,
        data: "Hết thời gian yêu cầu máy chủ",
        type: "error"
      });
    }, 30000);

    const resfunc = response => {
      clearTimeout(timeoutId);
      if (!response) {
        return resolve({ code: 503, message: "no_response", type: "error" });
      }

      if (!response.ok && response.status === 500) {
        return response
          .text()
          .then(msg =>
            resolve({ code: response.status, message: msg, type: "error" })
          );
      }

      if (!response.ok) {
        return response.text().then(text => {
          let msg;
          try {
            msg = JSON.parse(text);
          } catch (e) {
            msg = text || response.statusText;
          }
      
          return resolve({
            code: response.status,
            message: msg,
            type: "error"
          });
        });
      }

      // lỗi hệ thống k xử lý được?
      if (response.status === 299) {
        return response
          .text()
          .then(msg =>
            resolve({ code: response.status, message: msg, type: "warning" })
          );
      }

      const contentType = response.headers.get("content-type");
      if (contentType && contentType.indexOf("application/json") !== -1) {
        return response.json();
      }

      return response.text();
    };

    const errfunc = err => {
      console.error(err);
      clearTimeout(timeoutId);
      return resolve({ code: 500, message: "Quá thời gian", type: "error" });
    };

    fetch(path, {
      method: method,
      mode: "cors",
      headers: getHeaders(),
      body: data !== null ? JSON.stringify(data) : null
    })
      .then(resfunc, errfunc)
      .then(resdata => {
        if (!resdata) {
          // TODO throw new Error(MESSAGE.cscore_tnn_ERROR);
          return resolve({ code: 200, data: [], type: "success" });
        }

        // console.info("APIService successful at ", resdata);
        if (resdata.code) {
          return resdata;
        }
        return resolve({ code: 200, data: resdata, type: "success" });
      });
  });
}

export function callApiInputToken({ method, path, data, getBody, token }) {
  if (method !== "GET" && method !== "DELETE" && method !== "PUT") {
    method = "POST";
  }
  if (method === "GET") {
    const qr = queryString.stringify({ ...data });
    if (qr !== "") {
      path = path + "?" + qr;
    }
    if (getBody) {
      data = getBody;
    } else {
      data = null;
    }
  }

  return new Promise((resolve, reject) => {
    const timeoutId = setTimeout(() => {
      return resolve({
        code: 408,
        data: "Hết thời gian yêu cầu máy chủ",
        type: "error"
      });
    }, 30000);

    const resfunc = response => {
      clearTimeout(timeoutId);
      if (!response) {
        return resolve({ code: 503, message: "no_response", type: "error" });
      }

      if (!response.ok && response.status === 500) {
        return response
          .text()
          .then(msg =>
            resolve({ code: response.status, message: msg, type: "error" })
          );
      }

      if (!response.ok) {
        return response.text().then(text => {
          let msg;
          try {
            msg = JSON.parse(text);
          } catch (e) {
            msg = text || response.statusText;
          }
      
          return resolve({
            code: response.status,
            message: msg,
            type: "error"
          });
        });
      }

      // lỗi hệ thống k xử lý được?
      if (response.status === 299) {
        return response
          .text()
          .then(msg =>
            resolve({ code: response.status, message: msg, type: "warning" })
          );
      }

      const contentType = response.headers.get("content-type");
      if (contentType && contentType.indexOf("application/json") !== -1) {
        return response.json();
      }

      return response.text();
    };

    const errfunc = err => {
      console.error(err);
      clearTimeout(timeoutId);
      return resolve({ code: 500, message: "Quá thời gian", type: "error" });
    };

    fetch(path, {
      method: method,
      mode: "cors",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token
      },
      body: data !== null ? JSON.stringify(data) : null
    })
      .then(resfunc, errfunc)
      .then(resdata => {
        if (!resdata) {
          // TODO throw new Error(MESSAGE.cscore_tnn_ERROR);
          return resolve({ code: 200, data: [], type: "success" });
        }

        // console.info("APIService successful at ", resdata);
        if (resdata.code) {
          return resdata;
        }
        return resolve({ code: 200, data: resdata, type: "success" });
      });
  });
}

function callAPIUploadFile({ data }) {
  const method = "POST";
  console.log(data);
  return fetch(API_DMS_URI + `upload`, {
    method: method,
    body: data,
    headers: getHeaderFile()
  })
    .then(response => {
      if (!response) {
        // TODO
        return;
      }

      if (!response.ok) {
        // TODO
        return;
      }

      // lỗi hệ thống k xử lý được?
      if (response.status === 299) {
        return response.json().then(err => {
          throw new Error(err && err.message);
        });
      }

      return response.json();
    })
    .then(resdata => {
      if (!resdata) {
        // throw new Error(MESSAGE.cscore_tnn_ERROR);
        return;
      }
      return resdata;
    });
}

function callAPIDownloadFile({ data }) {
  const path = API_DMS_URI + "download";
  const method = "POST";

  let canopen = false;
  if (data && data.file_name) {
    let arr = data.file_name.split(".");
    if (arr && arr.length > 0 && arr[arr.length - 1].toUpperCase() === "PDF") {
      canopen = true;
    }
  }

  if (canopen) {
    return fetch(path, {
      method: method,
      headers: getHeaders(),
      responseType: "blob",
      body: data !== null ? JSON.stringify(data) : null
    })
      .then(response => {
        if (!response) {
          // TODO
          return;
        }

        if (!response.ok) {
          // TODO
          return;
        }

        // lỗi hệ thống k xử lý được?
        if (response.status === 299) {
          return response.json().then(err => {
            throw new Error(err && err.message);
          });
        }

        return response.arrayBuffer();
      })
      .then(resdata => {
        if (!resdata) {
          // TODO throw new Error(MESSAGE.cscore_tnn_ERROR);
          return;
        }

        window.open(
          URL.createObjectURL(new Blob([resdata], { type: "application/pdf" }))
        );
      });
  }

  return fetch(path, {
    method: method,
    headers: getHeaders(),
    responseType: "blob",
    body: data !== null ? JSON.stringify(data) : null
  })
    .then(response => {
      if (!response) {
        // TODO
        return;
      }

      if (!response.ok) {
        // TODO
        return;
      }

      // lỗi hệ thống k xử lý được?
      if (response.status === 299) {
        return response.json().then(err => {
          throw new Error(err && err.message);
        });
      }

      return response.blob();
    })
    .then(resdata => {
      if (!resdata) {
        return;
      }

      const url = window.URL.createObjectURL(resdata);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", data.file_name);
      document.body.appendChild(link);
      link.click();
    });
}
const callExportFile = ({ path, method, fileName }) => {
  fetch(path, {
    method: method,
    headers: getHeaders(),
    responseType: "blob"
  })
    .then(response => {
      return response.blob();
    })
    .then(blob => {
      const timestamp = new Date().getTime();
      // Tạo URL tạm thời cho blob
      const blobUrl = URL.createObjectURL(blob);

      // Tạo một đối tượng <a> với download attribute
      const a = document.createElement("a");
      a.href = blobUrl;
      a.download = fileName;
      // Thêm đối tượng <a> vào DOM
      document.body.appendChild(a);
      // Kích hoạt sự kiện click trên đối tượng <a>
      a.click();
      // Loại bỏ đối tượng <a> khỏi DOM sau khi tải xuống
      document.body.removeChild(a);
    });
};
const callExportFileDataInput = ({ path, method, fileName, data }) => {
  fetch(path, {
    method: method,
    headers: getHeaders(),
    responseType: "blob",
    body: data?.data !== null ? JSON.stringify(data.data) : null
  })
    .then(response => {
      return response.blob();
    })
    .then(blob => {
      const timestamp = new Date().getTime();
      // Tạo URL tạm thời cho blob
      const blobUrl = URL.createObjectURL(blob);

      // Tạo một đối tượng <a> với download attribute
      const a = document.createElement("a");
      a.href = blobUrl;
      a.download = fileName;
      // Thêm đối tượng <a> vào DOM
      document.body.appendChild(a);
      // Kích hoạt sự kiện click trên đối tượng <a>
      a.click();
      // Loại bỏ đối tượng <a> khỏi DOM sau khi tải xuống
      document.body.removeChild(a);
    });
};
export default class Api {
  Login = async ({ data }) =>
    callAPI({
      path: API_CORE_URI + "login",
      method: "POST",
      data: data || {}
    });
  RefreshToken = async ({ data }) =>
    callAPI({
      path: API_CORE_URI + "refresh-token",
      method: "POST",
      data: data || {}
    });
  UploadFile = async ({ data, token }) =>
    callAPIUploadFile({ data: data, token: token });
  DownloadFile = async ({ data }) => callAPIDownloadFile({ data: data });
  GetUrlImageFile = async ({ data }) =>
    callAPI({
      path: API_DMS_URI + "download/url-image",
      method: "GET",
      data: data
    });
  Profile = async () =>
    callAPI({ path: API_CORE_URI + "user/profile", method: "GET" });
  CheckToken = async (token) =>
    callApiInputToken({ path: API_CORE_URI + "user/profile", method: "GET", token: token });
  getKinhTuyentruc = async ({ cap }) =>
    callAPI({
      path: API_CORE_URI + "DMKinhTuyenTruc",
      method: "GET",
      data: { cap }
    });
  GetDMCoQuanQuanLys = async ({ page, size, strSearch } = {}) =>
    callAPI({
      path: API_CORE_URI + "dmcoquanquanly",
      data: { page, size, strSearch }
    });
  ResetPassword = async ({ curentPassword, model }) =>
    callAPI({
      path:
        API_CORE_URI + `user/resetpassword?curentPassword=${curentPassword}`,
      data: model
    });
  UpdateProfile = async ({ model }) =>
    callAPI({
      path: API_CORE_URI + `user/profile`,
      method: "POST",
      data: model
    });
  GetUsers = async () =>
    callAPI({ path: API_CORE_URI + "user/getusers", method: "GET" });
  GetUserByUserName = async ({ username }) =>
    callAPI({
      path: API_CORE_URI + "user/getuserbyusername",
      method: "GET",
      data: { username }
    });
  GetDM_DonVis = async ({ strSearch, page, size, order_by_clause = "" } = {}) =>
    callAPI({
      path: API_CORE_URI + "DM_DonViDo/getList",
      method: "GET",
      data: { strSearch, page, size, order_by_clause }
    });
  getFunctionsByRole = async ({ app_code = "cscore_vanhanh_spa_mt" } = {}) =>
    callAPI({
      path: API_CORE_URI + "functions/funcbyrole",
      method: "GET",
      data: { app_code }
    });

  getAllDanhMucs = async ({} = {}) =>
    callAPI({
      path: API_URI + "list-dashboard-danhmucs",
      method: "GET",
      data: {}
    });
  // Update data DanhMuc DB to BE
  updateDataDanhMuc = async () =>
    callAPI({
      path: API_URI + "update-danhmucs",
      method: "GET"
    });
  getListAllTinhThanhs = async ({} = {}) =>
    callAPI({ path: API_URI + "list-all-tinhthanhs", method: "GET", data: {} });
  getListAllQuanHuyens = async ({ maTinh } = {}) =>
    callAPI({
      path: API_URI + "list-all-quanhuyens",
      method: "GET",
      data: { maTinh }
    });
  getListAllPhuongXas = async ({ maHuyen } = {}) =>
    callAPI({
      path: API_URI + "list-all-phuongxas",
      method: "GET",
      data: { maHuyen }
    });
  ListNhatKyHeThongDangNhap = async data =>
    callAPI({
      path: API_URI + `nhatkyhethong-dangnhaps`,
      method: "POST",
      data: data
    });
  GetNhatKyHeThongDangNhap = async ({ id } = {}) =>
    callAPI({ path: API_URI + `nhatkyhethong-dangnhap/${id}`, method: "GET" });

  ListNhatKyHeThong = async data =>
    callAPI({
      path: API_URI + `nhatkyhethongs`,
      method: "POST",
      data: data
    });
  GetNhatKyHeThong = async ({ id } = {}) =>
    callAPI({ path: API_URI + `nhatkyhethong/${id}`, method: "GET" });

  //API dvhc
  GetListDvhc = async ({ cap, madvhc } = {}) =>
    callAPI({
      path: API_CORE_URI + `dmDvhc?cap=${cap}&madvhc=${madvhc}`,
      method: "GET",
      data: {}
    });

  ////////
  Add_QuanLyNguoiDung = async ({ data }) =>
    callAPI({
      path: API_CORE_URI + `user/register`,
      method: "POST",
      data: data
    });
  Update_QuanLyNguoiDung = async ({ data }) =>
    callAPI({
      path: API_CORE_URI + `user/profile`,
      method: "POST",
      data: data
    });
  GetListQuanLyNguoiDung = async ({ tuKhoa, limit, anchor } = {}) =>
    callAPI({
      path: API_CORE_URI + "user/nghiepvu/getusers",
      method: "POST",
      data: { tuKhoa, limit, anchor }
    });
  GetQuanLyNguoiDungByUserName = async ({ userName } = {}) =>
    callAPI({
      path: API_CORE_URI + `user/getuserbyusername?username=${userName}`,
      method: "GET",
      data: {}
    });
  DeleteQuanLyNguoiDungByUserName = async ({ userName } = {}) =>
    callAPI({
      path: API_CORE_URI + `user/DeleteUser`,
      method: "DELETE",
      data: userName
    });

  GetChucVuList = async () =>
    callAPI({
      path: API_CORE_URI + `dmchucvu`,
      method: "GET",
      data: {}
    });
  GetPhongBanList = async () =>
    callAPI({
      path: API_CORE_URI + `dmphongban`,
      method: "GET",
      data: {}
    });
  GetCoQuanQuanLyList = async () =>
    callAPI({
      path: API_CORE_URI + `dmcoquanquanly`,
      method: "GET",
      data: {}
    });
  GetRolesByCapList = async () =>
    callAPI({
      path: API_CORE_URI + `author/rolesbycap`,
      method: "GET",
      data: {}
    });

  UpsertCoSoPhanPhoi = async ({ data }) =>
    callAPI({
      path: API_CORE_URI + "dm_cosophanphoi/upsert",
      method: "POST",
      data: data || {}
    });
  DeleteCoSoPhanPhoiById = async ({ id } = {}) =>
    callAPI({
      path: API_CORE_URI + `dm_cosophanphoi/delete/${id}`,
      method: "POST"
    });
  GetCoSoPhanPhoiById = async ({ id } = {}) =>
    callAPI({
      path: API_CORE_URI + `dm_cosophanphoi/${id}`,
      method: "GET",
      data: {}
    });
  GetListCoSoPhanPhoi = async ({ tuKhoa, limit, anchor } = {}) =>
    callAPI({
      path: API_CORE_URI + `dm_cosophanphois`,
      method: "POST",
      data: { tuKhoa, limit, anchor }
    });
  GetListCoSoPhanPhoiOfLoHang = async ({} = {}) =>
    callAPI({
      path: API_CORE_URI + `dm_cosophanphoi/getlist`,
      method: "GET",
      data: {}
    });
  LockCoSoPhanPhoi = async ({ data }) =>
    callAPI({
      path: API_CORE_URI + "dm_cosophanphoi/lock_unlock",
      method: "POST",
      data: data || {}
    });

  UpsertCoSoSanXuat = async ({ data }) =>
    callAPI({
      path: API_CORE_URI + "dm_cososanxuat/upsert",
      method: "POST",
      data: data || {}
    });
  DeleteCoSoSanXuatById = async ({ id } = {}) =>
    callAPI({
      path: API_CORE_URI + `dm_cososanxuat/delete/${id}`,
      method: "POST"
    });
  GetCoSoSanXuatById = async ({ id } = {}) =>
    callAPI({
      path: API_CORE_URI + `dm_cososanxuat/${id}`,
      method: "GET",
      data: {}
    });
  GetListCoSoSanXuat = async ({ tuKhoa, limit, anchor } = {}) =>
    callAPI({
      path: API_CORE_URI + `dm_cososanxuats`,
      method: "POST",
      data: { tuKhoa, limit, anchor }
    });
  GetListCoSoSanXuatOfLoHang = async ({} = {}) =>
    callAPI({
      path: API_CORE_URI + `dm_cososanxuat/getlist`,
      method: "GET",
      data: {}
    });
  GetListCoSoSanXuatOfLichSuCheBien = async (data) =>
    callAPI({
      path: API_CORE_URI + `filter_cssx`,
      method: "POST",
      data: data
    });
    // callAPI({
    //   path: API_CORE_URI + `filter_cssx`,
    //   method: "GET",
    //   data: {}
    // });
  LockCoSoSanXuat = async ({ data }) =>
    callAPI({
      path: API_CORE_URI + "dm_cososanxuat/lock_unlock",
      method: "POST",
      data: data || {}
    });
    
  UpsertCoSoCheBien = async ({ data }) =>
    callAPI({
      path: API_CORE_URI + "dm_cosochebien/upsert",
      method: "POST",
      data: data || {}
    });
  DeleteCoSoCheBienById = async ({ id } = {}) =>
    callAPI({
      path: API_CORE_URI + `dm_cosochebien/delete/${id}`,
      method: "POST"
    });
  GetCoSoCheBienById = async ({ id } = {}) =>
    callAPI({
      path: API_CORE_URI + `dm_cosochebien/${id}`,
      method: "GET",
      data: {}
    });
  GetListCoSoCheBien = async ({ tuKhoa, limit, anchor } = {}) =>
    callAPI({
      path: API_CORE_URI + `dm_cosochebiens`,
      method: "POST",
      data: { tuKhoa, limit, anchor }
    });
  GetListCoSoCheBienOfLoHang = async ({} = {}) =>
    callAPI({
      path: API_CORE_URI + `dm_cosochebien/getlist`,
      method: "GET",
      data: {}
    });
  UpsertDuLieuThongKe = async ({ data }) =>
    callAPI({
      path: API_CORE_URI + "dulieuthongke/upsert",
      method: "POST",
      data: data || {}
    });
  DeleteDuLieuThongKeById = async ({ id } = {}) =>
    callAPI({
      path: API_CORE_URI + `dulieuthongke/delete/${id}`,
      method: "POST"
    });
  GetDuLieuThongKeById = async ({ id } = {}) =>
    callAPI({
      path: API_CORE_URI + `dulieuthongke/${id}`,
      method: "GET",
      data: {}
    });
  GetListDuLieuThongKe = async ({ tuKhoa, limit, anchor } = {}) =>
    callAPI({
      path: API_CORE_URI + `dulieuthongkes`,
      method: "POST",
      data: { tuKhoa, limit, anchor }
    });

  UpsertDuLieuKhiHau = async ({ data }) =>
    callAPI({
      path: API_CORE_URI + "dulieukhihau/upsert",
      method: "POST",
      data: data || {}
    });
  DeleteDuLieuKhiHauById = async ({ id } = {}) =>
    callAPI({
      path: API_CORE_URI + `dulieukhihau/delete/${id}`,
      method: "POST"
    });
  GetDuLieuKhiHauById = async ({ id } = {}) =>
    callAPI({
      path: API_CORE_URI + `dulieukhihau/${id}`,
      method: "GET",
      data: {}
    });
  GetListDuLieuKhiHau = async ({ tuKhoa, limit, anchor } = {}) =>
    callAPI({
      path: API_CORE_URI + `dulieukhihaus`,
      method: "POST",
      data: { tuKhoa, limit, anchor }
    });

  UpsertBaoCaoChuyenDe = async ({ data }) =>
    callAPI({
      path: API_CORE_URI + "baocaochuyende/upsert",
      method: "POST",
      data: data || {}
    });
  DeleteBaoCaoChuyenDeById = async ({ id } = {}) =>
    callAPI({
      path: API_CORE_URI + `baocaochuyende/delete/${id}`,
      method: "POST"
    });
  GetBaoCaoChuyenDeById = async ({ id } = {}) =>
    callAPI({
      path: API_CORE_URI + `baocaochuyende/${id}`,
      method: "GET",
      data: {}
    });
  GetListBaoCaoChuyenDe = async ({ tuKhoa, limit, anchor } = {}) =>
    callAPI({
      path: API_CORE_URI + `baocaochuyendes`,
      method: "POST",
      data: { tuKhoa, limit, anchor }
    });

  UpsertSanPham = async ({ data }) =>
    callAPI({
      path: API_CORE_URI + "sanpham/upsert",
      method: "POST",
      data: data || {}
    });
  DeleteSanPhamById = async ({ id } = {}) =>
    callAPI({
      path: API_CORE_URI + `sanpham/delete/${id}`,
      method: "POST"
    });
  GetSanPhamById = async ({ id } = {}) =>
    callAPI({
      path: API_CORE_URI + `sanpham/${id}`,
      method: "GET",
      data: {}
    });
  GetListSanPham = async ({ tuKhoa, limit, anchor } = {}) =>
    callAPI({
      path: API_CORE_URI + `sanphams`,
      method: "POST",
      data: { tuKhoa, limit, anchor }
    });
  GetListSanPhamOfLoHang = async ({} = {}) =>
    callAPI({
      path: API_CORE_URI + `sanpham/getlist`,
      method: "GET",
      data: {}
    });
  LockSanPham = async ({ data }) =>
    callAPI({
      path: API_CORE_URI + "sanpham/lock_unlock",
      method: "POST",
      data: data || {}
    });
  GetLogSanPhams = async ({ idsanpham } = {}) =>
    callAPI({
      path: API_CORE_URI + `sanpham/logs`,
      method: "GET",
      data: { idsanpham }
    });
  UpsertThongTinDoanhNghiep = async ({ data }) =>
    callAPI({
      path: API_CORE_URI + "doanhnghiep/upsert",
      method: "POST",
      data: data || {}
    });
  DeleteThongTinDoanhNghiepById = async ({ id } = {}) =>
    callAPI({
      path: API_CORE_URI + `doanhnghiep/delete/${id}`,
      method: "POST"
    });
  GetThongTinDoanhNghiepById = async ({ id } = {}) =>
    callAPI({
      path: API_CORE_URI + `doanhnghiep/${id}`,
      method: "GET",
      data: {}
    });
  GetListThongTinDoanhNghiep = async ({ tuKhoa, limit, anchor } = {}) =>
    callAPI({
      path: API_CORE_URI + `doanhnghieps`,
      method: "POST",
      data: { tuKhoa, limit, anchor }
    });
  GetListSelectDoanhNghiep = async () =>
    callAPI({
      path: API_CORE_URI + `doanhnghiep/getlist`,
      method: "GET",
      data: {}
    });
  LockThongTinDoanhNghiep = async ({ data }) =>
    callAPI({
      path: API_CORE_URI + "doanhnghiep/lock_unlock",
      method: "POST",
      data: data || {}
    });
  UpsertVungSanXuat = async ({ data }) =>
    callAPI({
      path: API_CORE_URI + "vungsanxuat/upsert",
      method: "POST",
      data: data || {}
    });
  DeleteVungSanXuatById = async ({ id } = {}) =>
    callAPI({
      path: API_CORE_URI + `vungsanxuat/delete/${id}`,
      method: "POST"
    });
  GetVungSanXuatById = async ({ id } = {}) =>
    callAPI({
      path: API_CORE_URI + `vungsanxuat/${id}`,
      method: "GET",
      data: {}
    });
  GetListVungSanXuat = async ({ tuKhoa, limit, anchor } = {}) =>
    callAPI({
      path: API_CORE_URI + `vungsanxuats`,
      method: "POST",
      data: { tuKhoa, limit, anchor }
    });
  UpsertLoHang = async ({ data }) =>
    callAPI({
      path: API_CORE_URI + "lohang/upsert",
      method: "POST",
      data: data || {}
    });
  DeleteLoHangById = async ({ id } = {}) =>
    callAPI({
      path: API_CORE_URI + `lohang/delete/${id}`,
      method: "POST"
    });
  GetLoHangById = async ({ id } = {}) =>
    callAPI({
      path: API_CORE_URI + `lohang/${id}`,
      method: "GET",
      data: {}
    });
  GetListLoHang = async ({ tuKhoa, limit, anchor } = {}) =>
    callAPI({
      path: API_CORE_URI + `lohangs`,
      method: "POST",
      data: { tuKhoa, limit, anchor }
    });
  GetQrLoHangById = async ({ id } = {}) =>
    callAPI({
      path: API_CORE_URI + `lohang/display_qrcode/${id}`,
      method: "GET",
      data: {}
    });
  GetLogLoHangs = async ({ idlohang } = {}) =>
    callAPI({
      path: API_CORE_URI + `lohang/logs`,
      method: "GET",
      data: { idlohang }
    });
  UpsertLichSuSanXuat = async ({ data }) =>
    callAPI({
      path: API_CORE_URI + "lssanxuat/upsert",
      method: "POST",
      data: data || {}
    });
  DeleteLichSuSanXuatById = async ({ id } = {}) =>
    callAPI({
      path: API_CORE_URI + `lssanxuat/delete/${id}`,
      method: "POST"
    });
  GetLichSuSanXuatById = async ({ id } = {}) =>
    callAPI({
      path: API_CORE_URI + `lssanxuat/${id}`,
      method: "GET",
      data: {}
    });
  GetListLichSuSanXuat = async ({ tuKhoa, limit, anchor } = {}) =>
    callAPI({
      path: API_CORE_URI + `lssanxuats`,
      method: "POST",
      data: { tuKhoa, limit, anchor }
    });
  UpsertThongTinLichSuSanXuat = async ({ data }) =>
    callAPI({
      path: API_CORE_URI + "lsthongtinsanxuat/upsert",
      method: "POST",
      data: data || {}
    });
  DeleteThongTinLichSuSanXuatById = async ({ id } = {}) =>
    callAPI({
      path: API_CORE_URI + `lsthongtinsanxuat/delete/${id}`,
      method: "POST"
    });
  GetThongTinLichSuSanXuatById = async ({ id } = {}) =>
    callAPI({
      path: API_CORE_URI + `lsthongtinsanxuat/${id}`,
      method: "GET",
      data: {}
    });
  GetListThongTinLichSuSanXuat = async ({ tuKhoa, limit, anchor } = {}) =>
    callAPI({
      path: API_CORE_URI + `lsthongtinsanxuats`,
      method: "POST",
      data: { tuKhoa, limit, anchor }
    });
  GetListThongTinLichSuSanXuatOfThongTinCheBien = async (data) =>
    callAPI({
      path: API_CORE_URI + `lsthongtinsanxuat/getlist`,
      method: "POST",
      data: data
    });
  UpsertThongTinLichSuCheBien = async ({ data }) =>
    callAPI({
      path: API_CORE_URI + "lsthongtinchebien/upsert",
      method: "POST",
      data: data || {}
    });
  DeleteThongTinLichSuCheBienById = async ({ id } = {}) =>
    callAPI({
      path: API_CORE_URI + `lsthongtinchebien/delete/${id}`,
      method: "POST"
    });
  GetThongTinLichSuCheBienById = async ({ id } = {}) =>
    callAPI({
      path: API_CORE_URI + `lsthongtinchebien/${id}`,
      method: "GET",
      data: {}
    });
  GetListThongTinLichSuCheBien = async ({ tuKhoa, limit, anchor } = {}) =>
    callAPI({
      path: API_CORE_URI + `lsthongtinchebiens`,
      method: "POST",
      data: { tuKhoa, limit, anchor }
    });
  GetListThongTinLichSuCheBienOfCoSoCheBien = async (data) =>
    callAPI({
      path: API_CORE_URI + `lsthongtinchebien/getlist`,
      method: "POST",
      data: data
    });
  UpsertThongTinLichSuPhanPhoi = async ({ data }) =>
    callAPI({
      path: API_CORE_URI + "lsthongtinphanphoi/upsert",
      method: "POST",
      data: data || {}
    });
  DeleteThongTinLichSuPhanPhoiById = async ({ id } = {}) =>
    callAPI({
      path: API_CORE_URI + `lsthongtinphanphoi/delete/${id}`,
      method: "POST"
    });
  GetThongTinLichSuPhanPhoiById = async ({ id } = {}) =>
    callAPI({
      path: API_CORE_URI + `lsthongtinphanphoi/${id}`,
      method: "GET",
      data: {}
    });
  GetListThongTinLichSuPhanPhoi = async ({ tuKhoa, limit, anchor } = {}) =>
    callAPI({
      path: API_CORE_URI + `lsthongtinphanphois`,
      method: "POST",
      data: { tuKhoa, limit, anchor }
    });
  GetCauHinhHienThi = async () =>
    callAPI({
      path: API_CORE_URI + `display_config/gets_by_doanhnghiep`,
      method: "GET",
      data: {}
    });
  UpsertCauHinhHienThi = async ({ data }) =>
    callAPI({
      path: API_CORE_URI + "display_config/update",
      method: "POST",
      data: data || {}
    });

  UpsertQuanLySilde = async ({ data }) =>
    callAPI({
      path: API_CORE_URI + "slideshow/upsert",
      method: "POST",
      data: data || {}
    });
  DeleteQuanLySildeById = async ({ id } = {}) =>
    callAPI({
      path: API_CORE_URI + `slideshow/delete/${id}`,
      method: "POST"
    });
  GetQuanLySildeById = async ({ id } = {}) =>
    callAPI({
      path: API_CORE_URI + `slideshow/${id}`,
      method: "GET",
      data: {}
    });
  GetListQuanLySilde = async ({ tuKhoa, limit, anchor } = {}) =>
    callAPI({
      path: API_CORE_URI + `slideshows`,
      method: "POST",
      data: { tuKhoa, limit, anchor }
    });
  GetViTris = async () =>
    callAPI({
      path: API_CORE_URI + `vitris`,
      method: "GET",
      data: {}
    });
  UpsertQuanLyTinTuc = async ({ data }) =>
    callAPI({
      path: API_CORE_URI + "tintuc/upsert",
      method: "POST",
      data: data || {}
    });
  DeleteQuanLyTinTucById = async ({ id } = {}) =>
    callAPI({
      path: API_CORE_URI + `tintuc/delete/${id}`,
      method: "POST"
    });
  GetQuanLyTinTucById = async ({ id } = {}) =>
    callAPI({
      path: API_CORE_URI + `tintuc/${id}`,
      method: "GET",
      data: {}
    });
  GetListQuanLyTinTuc = async ({ tuKhoa, limit, anchor } = {}) =>
    callAPI({
      path: API_CORE_URI + `tintucs`,
      method: "POST",
      data: { tuKhoa, limit, anchor }
    });
  GetChuyenMucs = async () =>
    callAPI({
      path: API_CORE_URI + `danhmuc_tintucs`,
      method: "GET",
      data: {}
    });

  UpsertVungSanXuatSpatial = async ({ data }) =>
    callAPI({
      path: API_SPATIAL_URI + "MTSpatial/PostSpatial_VungSanXuat",
      method: "POST",
      data: data || {}
    });

  DeleteVungSanXuatSpatial = async ({ id } = {}) => 
    callAPI({ 
      path: API_SPATIAL_URI + `MTSpatial/DeleteSpatial_VungSanXuat/${id}`, 
      method: 'DELETE' 
    });
  GetDM_LinhVucs = async () =>
    callAPI({
      path: API_CORE_URI + `dmlinhvuc`,
      method: "GET",
      data: {}
    });
  GetListRole = async ({ tuKhoa, limit, anchor } = {}) =>
    callAPI({
      path: API_CORE_URI + `roles/getlist`,
      method: "POST",
      data: { tuKhoa, limit, anchor }
    });
  GetRoleById = async ({ id } = {}) =>
    callAPI({
      path: API_CORE_URI + `roles/${id}`,
      method: "GET",
      data: {}
    });
  AddRole = async ({ data }) =>
    callAPI({
      path: API_CORE_URI + "roles",
      method: "POST",
      data: data || {}
    });
  UpdateRole = async ({ data, id }) =>
    callAPI({
      path: API_CORE_URI + `roles/${id}`,
      method: "PUT",
      data: data || {}
    });
  DeleteRole = async ({ id } = {}) =>
    callAPI({
      path: API_CORE_URI + `roles/${id}`,
      method: "DELETE",
      data: {}
    });
  GetAppByIdLinhVuc = async ({ idlinhvuc, page, size } = {}) =>
    callAPI({
      path: API_CORE_URI + "apps/get_apps_bylinhvuc",
      method: "GET",
      data: { idlinhvuc, page, size }
    });
  GetRolesByCap = async ({ cap, linhVucId } = {}) =>
    callAPI({
      path: API_CORE_URI + "roles/rolesbycap",
      method: "GET",
      data: { cap, linhVucId }
    });
  GetFunctionByRoleId = async ({ appId, roleId } = {}) =>
    callAPI({
      path: API_CORE_URI + "functions/getbyroleid",
      method: "GET",
      data: { appId, roleId }
    });
  UpdateFunctionByRoleId = async ({ data, roleId }) =>
    callAPI({
      path: API_CORE_URI + `author/funcstorole?roleId=${roleId}`,
      method: "POST",
      data: data || {}
    });
  
  GetListModule = async ({ tuKhoa, limit, anchor, appId } = {}) =>
    callAPI({
      path: API_CORE_URI + `module/getlist`,
      method: "POST",
      data: { tuKhoa, limit, anchor, appId }
    });
  GetModuleById = async ({ id } = {}) =>
    callAPI({
      path: API_CORE_URI + `module/${id}`,
      method: "GET",
      data: {}
    });
  UpdateModule = async ({ data, id }) =>
    callAPI({
      path: API_CORE_URI + `module/${id}`,
      method: "PUT",
      data: data || {}
    });
  AddModule = async ({ data }) =>
    callAPI({
      path: API_CORE_URI + "module",
      method: "POST",
      data: data || {}
    });
  DeleteModule = async ({ id } = {}) =>
    callAPI({
      path: API_CORE_URI + `module/${id}`,
      method: "DELETE",
      data: {}
    });

  GetListFunction = async ({ tuKhoa, limit, anchor, appId } = {}) =>
    callAPI({
      path: API_CORE_URI + `functions/getlist`,
      method: "POST",
      data: { tuKhoa, limit, anchor, appId }
    });
  GetFunctionById = async ({ id } = {}) =>
    callAPI({
      path: API_CORE_URI + `functions/${id}`,
      method: "GET",
      data: {}
    });
  UpdateFunction = async ({ data, id }) =>
    callAPI({
      path: API_CORE_URI + `functions/${id}`,
      method: "PUT",
      data: data || {}
    });
  AddFunction = async ({ data }) =>
    callAPI({
      path: API_CORE_URI + "functions/add",
      method: "POST",
      data: data || {}
    });
  DeleteFunction = async ({ id } = {}) =>
    callAPI({
      path: API_CORE_URI + `functions/${id}`,
      method: "DELETE",
      data: {}
    });
  // Thống kê số lượng quét QR code
  GetThongKeSoLuongQuetQRCode = async ({ tuKhoa, limit, anchor } = {}) =>
    callAPI({
      path: API_CORE_URI + `thongke_soluongquet_qrcode`,
      method: "GET",
      data: { tuKhoa, limit, anchor }
    });
  GetThongKeSoLuongCoSo = async () =>
    callAPI({
      path: API_CORE_URI + 'thongke_soluong_cssx_cscb_cspp',
      method: 'GET',
      data: {}
    });
  GetThongKeSoLuongLoHangTheoCspp = async () =>
    callAPI({
      path: API_CORE_URI + 'thongke_soluonglohang_theocspp',
      method: 'GET',
      data: {}
    });
  GetThongKeDienTichTheoVungSanXuat = async () =>
    callAPI({
      path: API_CORE_URI + 'thongke_dientich_theovungsanxuat',
      method: 'GET',
      data: {}
    });
}
